/*
* === components/SystemAlertBanner.js (Enterprise UX Upgrade) ===
* Features: Smooth slide-in, modern gradient, subtle pulse animation, high legibility
*/
import React from 'react';
import { Box, Typography, Slide } from '@mui/material';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import { useSettings } from '../context/SettingsContext';
import { keyframes } from '@mui/system';

// Subtle pulse animation to gently draw attention without anxiety
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
`;

const SystemAlertBanner = () => {
    const { announcement, loading } = useSettings();

    // Don't show if loading, not active, or no message
    if (loading || !announcement?.active || !announcement?.message) return null;

    return (
        <Slide direction="down" in={true} mountOnEnter unmountOnExit>
            <Box sx={{ 
                width: '100%', 
                // Sleek, modern brand gradient (adjust to match BrightSparc's exact theme if needed)
                background: 'linear-gradient(90deg, #4a148c 0%, #7b1fa2 100%)', 
                color: 'white',
                py: 1.5,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                position: 'relative',
                zIndex: 1100 // Ensures it stays above the navbar shadows
            }}>
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 1.5,
                    maxWidth: 'lg',
                    margin: '0 auto',
                    textAlign: 'center'
                }}>
                    <CampaignRoundedIcon sx={{ 
                        animation: `${pulse} 2.5s infinite ease-in-out`,
                        color: '#ffeb3b', // A friendly pop of energy
                        fontSize: '1.5rem'
                    }} />
                    <Typography variant="body2" sx={{ 
                        fontWeight: 600, 
                        fontSize: '0.95rem',
                        letterSpacing: '0.3px',
                        textShadow: '0px 1px 2px rgba(0,0,0,0.2)'
                    }}>
                        {announcement.message}
                    </Typography>
                </Box>
            </Box>
        </Slide>
    );
};

export default SystemAlertBanner;